// src/components/Footer.tsx
import React from "react";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-black text-white py-12 px-6">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
        {/* Adres */}
        <div>
          <h3 className="font-bold text-xl mb-4">{t("footer.addressTitle")}</h3>
          <p>{t("footer.addressLine1")}</p>
          <p>{t("footer.addressLine2")}</p>
        </div>

        {/* İletişim */}
        <div>
          <h3 className="font-bold text-xl mb-4">{t("footer.contactTitle")}</h3>
          <p>{t("footer.phone1")}</p>
          <p>{t("footer.phone2")}</p>
          <div className="flex mt-2 -ml-2.5">
            <a
              href="https://www.instagram.com/dt.mertsakaryamuayenehanesi/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2.5 hover:text-pink-500 transition"
              aria-label="Instagram"
            >
              <FaInstagram size={24} />
            </a>
            <a
              href="https://www.facebook.com/olydentklinik"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2.5 hover:text-blue-600 transition"
              aria-label="Facebook"
            >
              <FaFacebookF size={24} />
            </a>
          </div>
        </div>

        {/* Çalışma Saatleri */}
        <div>
          <h3 className="font-bold text-xl mb-4">{t("footer.hoursTitle")}</h3>
          <p>{t("footer.hoursWeek")}</p>
          <p>{t("footer.hoursWeekend")}</p>
        </div>
      </div>

      <div className="mt-8 text-center text-gray-400 text-sm">
        {t("footer.copyright")}
      </div>
    </footer>
  );
};

export default Footer;
